export const belarusForUkraineTags = ['беларусы против войны', 'беларусы за украину'];
